// #region HTML IDs
// region HTML IDs
export const BASKET_WITH_GIGAKOMBI_BUTTON_ID = 'overlay-button-basket-gigakombi';
export const BASKET_WITHOUT_GIGAKOMBI_BUTTON_ID = 'overlay-button-basket';
export const LOADING_INDICATOR_CSS_SELECTOR = 'loading-container';
export const IMAGE_HEADER_CONTAINER = 'image-header-container';
export const DEVICE_FIRST_HEADLINE_CONTAINER = 'device-first-headline-container';
export const DEVICE_FIRST_HEADLINE_ID = 'device-first-headline';
export const ITEM_SUMMARY_CARD = 'item-summary-card';
export const DEVICE_NOTIFICATION = 'device-notification';
export const TARIFF_OPTION_TABS_CONTAINER = 'tariff-option-tabs-container';
export const SALESCHANNEL_OPTION_PICKER_CONTAINER = 'sales-channel-option-picker';
export const GIGAKOMBI_OPTION_PICKER_CONTAINER = 'gigakombi-option-picker';
export const RESTLAUFZEIT_OPTION_PICKER_CONTAINER = 'rlz-option-picker';
export const RESTLAUFZEIT_HEADLINE_CONTAINER = 'rlz-headline';
export const RESTLAUFZEIT_ICON_TEXT_CONTAINER = 'rlz-icon-text';
export const OFFER_SUMMARY_CARD_CONTAINER = 'tariff-details-offer-summary-card';
export const STICKY_PRICE_BAR_CONTAINER = 'tariff-details-sticky-price-bar';
export const GIGADEPOT_ICON_TEXT_CONTAINER = 'gigadepot-icon-text';
export const GIGADEPOT_PROMOTIONAL_CARD_CONTAINER = 'gigadepot-promotional-card';
export const CASHBACK_PROMOTIONAL_CARD_CONTAINER = 'cashback-promotional-card';
/**
 * Not found in the CMS HTML, will be created on the fly. Don't delete!
 */
export const DEFAULT_OVERLAY_CONTAINER_ID = 'tariff-overview-overlay';
export const GIGAKOMBI_OVERLAY_CONTAINER_ID = 'gigakombi-login-overlay';
export const HORIZONTAL_LIST_CONTAINER = 'horizontal-list-container';
export const ERROR_NOTIFICATION_CONTAINER_ID = 'error-notification';
export const RELATED_LINKS_CONTAINER_ID = 'related-links';
export const APP_CONTAINER_ID = 'tariff-detail-page';
export const TRADE_IN_PROMO_CONTAINER = 'trade-in-promo-container';
export const TAUSCHBONUS_PROMO_CONTAINER = 'tauschbonus-promo-container';
export const GIGADEPOT_ICON_TEXT_LINK = 'gigadepot-icon-text-link';
// endregion
// #endregion

export const DATA_AMOUNT_UNLIMITED = -1;
export const MAXIMUM_RED_PLUS_CARDS = 4;
